module.exports = "https://static.moomoo.com/components/top-trading-signals/images/title_underline.e91e362986.png";